// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"Popup__materialize-textarea___14niy","modal-2463794813":"Popup__modal-2463794813___-qvG_","container":"Popup__container___29jAW","popupContainer":"Popup__popupContainer___3KB7W","absoluteCross":"Popup__absoluteCross___2alzf","buttonContainer":"Popup__buttonContainer___8ipJ4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CoachPopup/Popup.scss
// module id = 1476
// module chunks = 0